import React from "react";
import PropTypes from "prop-types";
import useStyles from "./ProfessionalDetails.styles";

/**
 * Summary Notes read card (R1, R4): displays the loan's one free-text note, styled to match the
 * role read-cards above it (§HLD 10). Add/amend now happens through the Edit Professional
 * Details form (`EditProfessionalDetailsDialog`) — this component is read-only.
 */
const SummaryNotesSection = ({ notes }) => {
  const classes = useStyles();

  return (
    <div className={classes.roleCard}>
      <div className={classes.roleCardHead}>
        <b>Summary notes</b>
      </div>
      {notes ? (
        <div style={{ whiteSpace: "pre-wrap", marginTop: 2 }}>{notes}</div>
      ) : (
        <div className={classes.subtle} style={{ marginTop: 2 }}>
          No notes yet — use Edit (above) to add one.
        </div>
      )}
    </div>
  );
};

SummaryNotesSection.propTypes = {
  notes: PropTypes.string,
};

SummaryNotesSection.defaultProps = {
  notes: null,
};

export default SummaryNotesSection;
